import { render, staticRenderFns } from "./Properties.vue?vue&type=template&id=53355812&scoped=true&"
import script from "./Properties.vue?vue&type=script&lang=js&"
export * from "./Properties.vue?vue&type=script&lang=js&"
import style0 from "./Properties.vue?vue&type=style&index=0&id=53355812&lang=scss&scoped=true&"
import style1 from "./Properties.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53355812",
  null
  
)

export default component.exports